import React from 'react';
import Surface from '../ui/Surface';
import styles from './MarketIntelligence.module.css';

const MarketIntelligence = () => {
  return (
    <div className={styles.wrapper}>
      <Surface padding="lg" className={styles.panel}>
        <div className={styles.header}>
          <div>
            <h3>Market intelligence</h3>
            <p>DAT RateView, transit time, and market heat overlays are staged for the next release.</p>
          </div>
          <div className={styles.badge}>Coming soon</div>
        </div>
        <div className={styles.tiles}>
          <div className={styles.tile}>
            <span className={styles.tileLabel}>DAT RateView</span>
            <h4>Live rates</h4>
            <p>As soon as credentials are configured, we will surface 3, 15, and 30 day averages with margin guidance.</p>
          </div>
          <div className={styles.tile}>
            <span className={styles.tileLabel}>Market Heat</span>
            <h4>Carrier capacity</h4>
            <p>Regional heatmaps illustrate where capacity is tightening or relaxing so you can plan tenders accordingly.</p>
          </div>
          <div className={styles.tile}>
            <span className={styles.tileLabel}>Transit time</span>
            <h4>ETA automation</h4>
            <p>Estimated durations will populate automatically via Google Maps so teams can set accurate pickup windows.</p>
          </div>
        </div>
      </Surface>
    </div>
  );
};

export default MarketIntelligence;
